import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLtFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53659)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 30.46H49.9999V40.5174C49.9999 40.9934 49.6139 41.3795 49.1378 41.3795H0.862108C0.386034 41.3795 0 40.9934 0 40.5174V30.46Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271V19.5401H0V9.48262C0 9.00654 0.386034 8.62061 0.862108 8.62061Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 19.54H0V30.459H49.9999V19.54Z",
					fill: "#73AF00"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53659",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLtFlag);
export { ForwardRef as ReactComponent };
